<template>
  <div class="jikyuu-calc detail-item" v-if="editingData">

    <div class="head"><b>基本給（参考）</b></div>
    <div class="data">
      @{{ numberFormat(editingData.kihonkyuu) }} ×
      {{ editingData.syotei_work_month_times }}h =
      {{ numberFormat(calcKihonkyuu(editingData)) }}円
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import { useKoyouKeiyakuDetail } from '@/composable/koyoukeiyaku/detail';
import { numberFormat } from '@/filters/common';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  },
  setup() {
    const { getError } = useForm();
    const { calcKihonkyuu } = useKoyouKeiyakuDetail();

    return {
      getError,
      calcKihonkyuu,
      numberFormat
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';
</style>
